module.exports = __webpack_public_path__ + "img/phonics_lo.19926a88.jpg";